import CastButton from "~/components/player/CastButton";
import PlayButton from "~/components/player/PlayButton";
import Progress from "~/components/player/Progress";
import SongLyricsButton from "~/components/player/SongLyricsButton";
import SongMetadata from "~/components/player/SongMetadata";
import SongRequestButton from "~/components/player/SongRequestButton";
import SourceSelect from "~/components/player/SourceSelect";
import styles from "~/components/player/Toolbar.module.scss";
import VolumeControl from "~/components/player/VolumeControl";

export default function Toolbar() {
  return (
    <div class={styles.player}>
      <SongMetadata />
      <div class={styles["right-part"]}>
        <CastButton />
        <SourceSelect />
        <SongLyricsButton />
        <SongRequestButton />
        <Progress />
        <VolumeControl />
        <PlayButton />
      </div>
    </div>
  );
}
